import {
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  ReactNode,
} from 'react';
import { IFeature } from '../interfaces';

interface IFeatureState {
  feature: IFeature;
  setFeature: Dispatch<SetStateAction<IFeature>>;
}

interface IFeatureContextProviderProps {
  defaults?: Partial<IFeature>;
  children?: ReactNode;
}

export const defaultFeature: IFeature = {
  sailpoint: true,
  revoke: true,
  disableDocUpload: true,
  evs: false,
  idProofReNnroll: false,
};

const defaultFeatureState: IFeatureState = {
  feature: defaultFeature,
  setFeature: () => {},
};

const FeatureContext = createContext<IFeatureState>(defaultFeatureState);

export const useFeatureContext = () => {
  return useContext(FeatureContext);
};

export const FeatureContextProvider = (props: IFeatureContextProviderProps) => {
  const [feature, setFeature] = useState<IFeature>({
    ...defaultFeature,
    ...props.defaults,
  });

  return (
    <FeatureContext.Provider
      value={{
        feature,
        setFeature,
      }}>
      {props.children}
    </FeatureContext.Provider>
  );
};
